import { OrdersService } from 'src/services/Orders';

export const convertDateToDateTimeLocalFormat = date => {
  if (!date) return null;

  const timeTransformed = new Date(date).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${date.split('T')[0]}T${timeTransformed}`;
};

export const uploadDocument = async ({ documentType, uuid, file }) => {
  try {
    const {
      data: { preSignedURL, documentPublicURL },
    } = await OrdersService.postS3PresignedUrl({
      documentType,
      uuid,
    });

    await OrdersService.uploadFileToS3({
      preSignedURL,
      file,
    });

    const response = await OrdersService.saveInOrdersBackend({
      documentType,
      uuid,
      documentPublicURL,
    });

    return {
      documentURL: documentPublicURL,
      documentType,
      documentSource: 'FORNECEDOR_PORTAL',
      ...response.data,
    };
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const translateErrorMessages = (error, orderNumber) => {
  const exceptionHandlersByStatusCode = {
    404: `Pedido ${orderNumber} Não encontrado `,
    500: `Problema interno, por favor tentar novamente`,
    default: 'Houve um problema ao executar a ação, por favor tente novamente',
  };
  return (
    exceptionHandlersByStatusCode[error?.response.status] ||
    exceptionHandlersByStatusCode.default
  );
};

export const isValidShippingCost = (shippingCost, subtotal) => {
  const ratio = shippingCost / subtotal;

  const condition1 = subtotal <= 100 && ratio > 3;
  const condition2 = subtotal > 100 && shippingCost < 500 && ratio > 2;
  const condition3 = shippingCost >= 500 && ratio > 0.1;

  return !condition1 && !condition2 && !condition3;
};

export const isUrl = string => {
  try {
    // eslint-disable-next-line no-new
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};
